import { IDropdownOption } from '@fluentui/react';
import {
  JsonContentType,
  JsonContentTypeHeaderValue,
  JsonContentTypeTable,
  JsonContentTypeImageCarousel,
  JsonContentTypeImageUrl,
  JsonContentTypeString,
  JsonContentTypeVideo
} from '../shared';

export const brSampleJson = {
  type: JsonContentType.br,
  value: null
};

export const headerValueSampleJson: JsonContentTypeHeaderValue = {
  type: JsonContentType.headerValue,
  value: {
    header: 'HeaderValue: Sample Header',
    value: 'HeaderValue: Sample Value'
  }
};

export const headerSampleJson: JsonContentTypeString = {
  type: JsonContentType.header,
  value: 'Header: Sample Header'
};

export const iframeSampleJson: JsonContentTypeString = {
  type: JsonContentType.iframe,
  value: 'https://www.support.xbox.com'
};

export const tableSampleJson: JsonContentTypeTable = {
  type: JsonContentType.table,
  value: [
    {
      text1: 'Date',
      text2: 'Name',
      text3: 'Message'
    },
    {
      text1: '2020-01-28',
      text2: 'Kyle',
      text3: 'This is the table sample'
    }
  ]
};

export const textSampleJson: JsonContentTypeString = {
  type: JsonContentType.text,
  value: 'Text example'
};

export const urlSampleJson: JsonContentTypeString = {
  type: JsonContentType.url,
  value: 'https://mixer.com/chatHistoryUrlSample/'
};

export const imageCarouselSampleJson: JsonContentTypeImageCarousel = {
  type: JsonContentType.imageCarousel,
  value: [
    {
      type: 'imageUrl',
      value: {
        value:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Xbox_logo_%282019%29.svg/1024px-Xbox_logo_%282019%29.svg.png',
        caption: 'sample caption'
      }
    },
    {
      type: 'imageBytes',
      value: {
        value:
          'iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4 //8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg==',
        caption: 'sample caption'
      }
    }
  ]
};

export const imageUrlSampleJson: JsonContentTypeImageUrl = {
  type: JsonContentType.imageUrl,
  value: {
    value:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d7/Xbox_logo_%282019%29.svg/1024px-Xbox_logo_%282019%29.svg.png',
    caption: 'sample caption'
  }
};

export const imageBytesSampleJson: JsonContentTypeImageUrl = {
  type: JsonContentType.imageBytes,
  value: {
    value:
      'iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4 //8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg==',
    caption: 'sample caption'
  }
};

export const videoSampleJson: JsonContentTypeVideo = {
  type: JsonContentType.video,
  value: {
    url: 'https://youtu.be/sLFIsIrjF34',
    frames: [
      {
        time: 4
      }
    ]
  }
};

export const audioUrlSampleJson: JsonContentTypeImageUrl = {
  type: JsonContentType.audioUrl,
  value: {
    value: 'https://www2.cs.uic.edu/~i101/SoundFiles/BabyElephantWalk60.wav'
  }
};

export const sampleJsonOptions: IDropdownOption[] = [
  { data: brSampleJson, key: JsonContentType.br, text: JsonContentType.br },
  { data: headerValueSampleJson, key: JsonContentType.headerValue, text: JsonContentType.headerValue },
  { data: headerSampleJson, key: JsonContentType.header, text: JsonContentType.header },
  { data: iframeSampleJson, key: JsonContentType.iframe, text: JsonContentType.iframe },
  { data: tableSampleJson, key: JsonContentType.table, text: JsonContentType.table },
  { data: textSampleJson, key: JsonContentType.text, text: JsonContentType.text },
  { data: urlSampleJson, key: JsonContentType.url, text: JsonContentType.url },
  { data: imageCarouselSampleJson, key: JsonContentType.imageCarousel, text: JsonContentType.imageCarousel },
  { data: imageUrlSampleJson, key: JsonContentType.imageUrl, text: JsonContentType.imageUrl },
  { data: imageBytesSampleJson, key: JsonContentType.imageBytes, text: JsonContentType.imageBytes },
  { data: videoSampleJson, key: JsonContentType.video, text: JsonContentType.video },
  { data: audioUrlSampleJson, key: JsonContentType.audioUrl, text: JsonContentType.audioUrl }
];

// TODO: look into, is this supported?
// expo rt const hrSampleJson = {
//   type: JsonContentType.hr,
//   value:
// }

// TODO: look into, is this supported?
// expo rt const sectionHeaderSampleJson = {
//   type: JsonContentType.sectionHeader,
//   value:
// }
